<template>
  <div class="summary" :class="{ 'pt-5': !currentBrand }">
    <h4>{{ _T('Item(s) not available in selected location') }}</h4>
    <div></div>
    <ul>
      <li
        class="summary-card unavilable-items"
        v-for="(item, key) in unavailable_cart_items"
        :key="'remove_item' + key"
      >
        <item v-if="item.item_type !== 'combo_item'" :item="item"></item>
        <combo-item v-else :item="item"></combo-item>
      </li>
    </ul>
    <div class="remove-unavailableitems" v-if="unavailable_cart_items.length">
      <button class="btn btn-danger" @click="removeUnavailableItems">
        {{ _T('Remove All') }}
      </button>
    </div>
    <empty-cart v-else></empty-cart>
  </div>
</template>
<script>
import Item from './Items/Item'
import { mapGetters } from 'vuex'
import ComboItem from './Items/ComboItem'
import EmptyCart from '../../Blocks/Cart/EmptyCart'

export default {
  name: 'Items',
  components: {
    ComboItem,
    Item,
    EmptyCart,
  },
  computed: {
    ...mapGetters(['_T', 'unavailable_cart_items', 'currentBrand']),
  },
  methods: {
    removeUnavailableItems() {
      this.$store.dispatch('removeUnavailableItems')
    }
  }
}
</script>
<style lang="scss" scoped>
.body-rtl {
  .summary {
    text-align: right;
    margin-right: 2rem;
    ul {
      padding-right: 0;
    }
  }
}
.unavilable-items {
  background-color: #fbd9d9 !important;
}
.remove-unavailableitems {
  padding: 10px 10px 10px 0px;
}
</style>
